import React, {useState} from 'react';
import {FarewiseIcon} from "../assets/svgComponents/farewiseIcon";
import {FlightSearchBar} from "../components/search/flightSearchBar";
import GroupTripButton from "../components/buttons/groupTripButton";
import {initialFlightSearchData} from "../models/flightSearchData";
import {SelectorType} from "../models/FlightSearch";
import CategoryQuickSelect from "../components/categoryQuickSelection";
import FlightSearchSelection from "../components/selector/FlightSearchSelection";
import {useFlightSearchStore} from "../store/useFlightSearchStore";
import {useTranslation} from "../i18n/LanguageProvider";

import MobileHomePage from "../mobile/MobileHomePage";
import useIsMobile from "../hooks/useIsMobile";
import DiscoveryLinks from "../components/search/DiscoveryLinks";

function HomePage() {
    const isMobile = useIsMobile();
    const storeData = useFlightSearchStore((state) => state.data);
    const setData = useFlightSearchStore((state) => state.setData);
    const {t} = useTranslation();
    const [activeSelector, setActiveSelector] = useState<SelectorType | null>(null);
    const [flightSearchData, setFlightSearchData] = useState(
        storeData ?? initialFlightSearchData
    );

    if (isMobile) {
        return <MobileHomePage flightSearchData={flightSearchData} setFlightSearchData={setFlightSearchData} />;
    }

    return (
        <div
            className="relative flex flex-col px-4 sm:px-10 lg:px-20 pt-8 sm:pt-16 lg:pt-24 pb-8 justify-center gap-6 items-center transition-smooth">
            <div className="flex w-full justify-start lg:absolute lg:top-10 lg:left-20 lg:w-auto"><DiscoveryLinks onNavigate={() => setData(flightSearchData)}/></div>
            <FarewiseIcon/>

            <h1 className="text-3xl sm:text-5xl lg:text-6xl text-center font-bold tracking-tight text-[#2D2D2D] leading-tight transition-smooth">
                {t("home.headlineLine1")} – <br className="hidden sm:block"/>
                {t("home.headlineLine2")}
            </h1>

            <div className="h-2 sm:h-3"/>

            <div
                className="flex flex-col gap-3 w-full max-w-3xl justify-center items-center select-none transition-smooth">
                <FlightSearchBar
                    activeSelector={activeSelector}
                    setActiveSelector={setActiveSelector}
                    searchData={flightSearchData}
                    setSearchData={setFlightSearchData}
                />
                {activeSelector && (
                    <FlightSearchSelection
                        activeSelector={activeSelector}
                        setActiveSelector={setActiveSelector}
                        flightSearchData={flightSearchData}
                        setFlightSearchData={setFlightSearchData}
                    />
                )}
            </div>

            {!activeSelector && <CategoryQuickSelect/>}

            <div className="absolute top-6 sm:top-10 lg:flex hidden right-6 sm:right-10 lg:right-20 transition-all duration-300">
                <GroupTripButton expanded={true}/>
            </div>

            <div className="mt-3 lg:mt-2">
                <h3 className="text-[#A07DEA] font-bold tracking-tight text-sm sm:text-base transition-all duration-300">
                    © 2025 Farewise
                </h3>
            </div>
        </div>
    );
}

export default HomePage;
